import { mode } from '@chakra-ui/theme-tools';

function baseStyle(props) {
  var bg = mode('white', 'white')(props);
  var shadowColor = mode('brand.500', 'brand.500')(props);
  return {
    bg: 'var(--tooltip-bg)',
    border: '1px',
    borderColor: shadowColor,
    borderRadius: 'base',
    boxShadow: 'base',
    color: mode('gray.900', 'gray.900')(props),
    fontWeight: 'normal',
    fontSize: 'sm',
    px: 4,
    py: 3,
    maxW: '320px',
    zIndex: 'tooltip',
    '--tooltip-bg': "colors." + bg,
    '--popper-arrow-bg': 'var(--tooltip-bg)',
    '--popper-arrow-shadow-color': "colors." + shadowColor
  };
}

export default {
  baseStyle
};
//# sourceMappingURL=Tooltip.js.map